<template>
  <asc-container class="asc-release-notes-template">
    <asc-spinner-wrapper :loading="loading">
      <div v-html="releaseNotes"></div>
    </asc-spinner-wrapper>
  </asc-container>
</template>

<script>
import AscContainer from '@/components/atoms/AscContainer'
import AscSpinnerWrapper from '@/components/atoms/AscSpinnerWrapper'

export default {
  name: 'AscReleaseNotesTemplate',

  components: {
    AscContainer,
    AscSpinnerWrapper,
  },

  props: {
    releaseNotes: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss">
.asc-release-notes-template {
  .asc-header--h4 {
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 1px;
    line-height: 18px;
    margin-bottom: 16px;
  }
}
</style>
